export * from './proMembership';

const JOBFEED_SLICE_NAME = 'job/jobFeed';
const COMPANY_JOBFEED_SLICE_NAME = 'job/company_jobFeed';

const JOBDETAIL_SLICE_NAME = 'job/jobdetail';
const USER_SLICE_NAME = 'User';
const APP_CONTEXT_SLICE_NAME = 'AppContext';
const AUTH_SLICE_NAME = 'Auth';
const ADS_SLICE_NAME = 'Ads';
const COMPETITION_SLICE_NAME = 'Competition';

const AUTH_KEY = 'token';
const AUTH_TOKEN = `${process.env.NEXT_PUBLIC_APP_NAME}_USER_AUTH`;
const OBS_ID = `${process.env.NEXT_PUBLIC_APP_NAME}_SESSION_ID`;
const AUTH_EXPIRATION = 'tokenExpirationTime';

const STATUS = 'status';
const SECRET = 'ss';

const COOKIE_LOGIN_AUTH = `${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}_CK1`;
const COOKIE_USER_LAST_ACTIVE = `${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}_LASTACT`;
const COOKIE_RECRUITER = `R_TOKEN_${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}`;
const COOKIE_JINSTITUTES = 'jinstitute';
const DOMAIN = `${process.env.NEXT_PUBLIC_APP_NAME}.com`;

const COMPETITION_ID = 3;

const NOTIFICATION_STATUS = {
  UNREAD: 1,
  READ: 2,
};

const NON_AUTH_ENDPOINT = [
  'login',
  'register',
  'forgot',
  'resetpassword',
  'logout',
  'consent',
];

const NON_AUTH_PAGE = [
  'c',
  'k',
  'j',
  'r',
  'aboutus',
  'faq',
  'contact',
  'sitemap',
  'privacy',
  'terms',
  'refund',
  'course',
  'email-unsubscribe',
  'reactivate-account',
  'women_at_work',
  'ai-search',
  'cookiepolicy',
  'company',
  'courses',
  'course_unpublished_detail',
  'course_unpublished_list',
  'engineers_week',
  'epoch',
  'downloadapp',
  'jobs',
  'learning',
  'reset-password',
  'search',
  'product-jobs',
  'ecommerce-jobs',
  'fintech-edtech-jobs',
  'talent-bridge-hiring-drive',
  'talent-bridge-detail',
  'pro_talent',
  'cv-analyzer',
];

const PAGEID = {
  JOBFEED: 'jf',
  JOBDETAIL: 'jd',
  CATEGORY: 'cl',
  TAG: 'kl',
};

const PAGELIST_ID = {
  hp: '1',
  cl: '2',
  kl: '3',
  jd: '4',
  jf: '5',
  apj: '6',
  svj: '7',
  smj: '8',
  src: '9',
  reg: '10',
  ios: '13',
  ios_pro_mail: '15',
  ios_pro_msg: '16',
  renew_before_15: '101',
  renew_before_7: '102',
  renew_before_3: '103',
  renew_before_2: '104',
  renew_before_1: '105',
  renew_post_1: '106',
  renew_post_3: '107',
  renew_post_5: '108',
  renew_post_7: '109',
  renew_post_10: '110',
  renew_post_15: '111',
  renew_before_0: '112',
  incomplete_payment_mail: '100',
};

const TRACKING_ACTIONS = {
  17: 'jsClickMenuRenewPro_Success',
  18: 'jsMenuReactivatePro_Success',
  19: 'jsMenuUpgradetoPro_Success',
  20: 'jsSimilarJobTextLink_Success',
  21: 'jsJDInsightRightLink_Success',
  22: 'jsAppliedJobsStatusBanner_Success',
  23: 'jsAppliedJobsFollowupBanner_Success',
  24: 'jsProfileStatus_Success',
  27: 'jsRAWidget_Success',
  30: 'jsSCBanner_Success',
  31: 'jsRAWidget_Success',
  32: 'jsRAWidget_Success',
  100: 'jsIncompletePaymentMail_Success',
} as const;

const postingOptions = [
  {id: 0, name: 'Posting'},
  {id: 1, name: '< 3 Days'},
  {id: 2, name: 'Last 1 Week'},
  {id: 3, name: 'Last 2 Weeks'},
  {id: 4, name: 'Last 1 Month'},
  {id: 5, name: 'Last 3 Months'},
];

const experienceOptions = [
  {id: 0, name: 'Any Exp. Level'},
  {id: 1, name: '0 - 1 yrs'},
  {id: 2, name: '2 - 3 yrs'},
  {id: 3, name: '4 - 6 yrs'},
  {id: 4, name: '7 - 10 yrs'},
  {id: 5, name: '11 - 15 yrs'},
  {id: 6, name: '16 - 20 yrs'},
  {id: 7, name: '21 - 25 yrs'},
  {id: 8, name: '26+ yrs'},
];

const getRefCodeAndTracking = (refCode: any): string => {
  const trackingAction =
    TRACKING_ACTIONS[refCode as keyof typeof TRACKING_ACTIONS];
  return trackingAction;
};

const pageUrlMap: Record<string, string> = {
  '/j/': 'Job Description Page',
  '/search/': 'Search Listing Page',
  '/job/applied': 'Similar Jobs Page',
  '/jobfeed': 'Jobfeed',
  '/k/': 'Tag Page',
  '/c/': 'Category Page',
  '-jobs-in-': 'Location Listing Page',
  '/r/': 'Recruiter Profile Page',
  '/course': 'Course Listing Page',
  '/course/': 'Course Detail Page',
  '/company': 'Company List Page',
  '/courses': 'Course Listing Page',
  '/downloadapp': 'Download App Page',
  '/privacy': 'Privacy Page',
  '/terms': 'Terms Page',
  '-careers': 'Company Career Page',
  '/product-jobs': 'Product Jobs Page',
  '/ecommerce-jobs': 'Ecommerce Jobs Page',
  '/fintech-edtech-jobs': 'Fintech Jobs Page',
  '/meta': 'Tag Selection Page',
  '/interviews': 'Interview Page',
  '/pendingassessments': 'Pending Assessment Page',
  '/saved-jobs': 'Saved Jobs',
  '/applied-jobs': 'Applied Jobs Page',
  '/removedjobs': 'Removed Jobs Page',
  '/register': 'Register Page Overlay',
  '/pro_talent': 'Pro Talent Page',
  '/engineers_week': 'Engineers Week Landing Page',
  '/reset-password': 'Reset Password Page',
  '/registration': 'Onboarding Profile Edit',
};

const HIRIST_CATEGORY_ID_MAPPING: {[key: string]: string} = {
  '14': '14',
  '2': '7',
  '3': '1',
  '4': '12',
  '5': '4',
};

const HIRIST_CATEGORY_BLOG_ID_MAPPING: {[key: string]: string} = {
  '3': '19', // Other Technology
  '1': '22', // Backend
  '7': '24', // Data Science
  '8': '23', // Dev Ops
  '2': '21', // Frontend
  '5': '20', // Mobile Applications
  '13': '25', // Project Management
  '11': '27', // Quality Assurance
  '6': '28', // SAP/Oracle
  '10': '26', // UI/UX Design
};

const CAT_ID_URL_MAPPING: {[key: string]: string} = {
  '3': '',
  '1': 'backend/',
  '7': 'data-science/',
  '8': 'devops/',
  '2': 'frontend/',
  '5': 'mobile-applications/',
  '13': 'project-management/',
  '11': 'quality-assurance/',
  '6': 'sap-oracle/',
  '10': 'ui-ux-design/',
};

const EXPERIENCE_MAPPING = [
  {minexp: 0, maxexp: 30},
  {minexp: 0, maxexp: 1},
  {minexp: 2, maxexp: 3},
  {minexp: 4, maxexp: 6},
  {minexp: 7, maxexp: 10},
  {minexp: 11, maxexp: 15},
  {minexp: 16, maxexp: 20},
  {minexp: 21, maxexp: 25},
  {minexp: 25, maxexp: 100},
];

const mapExpToBucket = (min?: number, max?: number): number | undefined => {
  if (min == null || max == null) return undefined;
  if (min <= 0 && max <= 1) return 2;
  if (min >= 2 && max <= 3) return 3;
  if (min >= 4 && max <= 6) return 4;
  if (min >= 7 && max <= 10) return 5;
  if (min >= 11 && max <= 15) return 6;
  if (min >= 16 && max <= 20) return 7;
  if (min >= 21 && max <= 25) return 8;
  if (min >= 25) return 9;
  return undefined;
};

const LOCATION_BASED = 'location_based';
const CATEGORY = 'category';
const COMPANY = 'company';

const JOBAPPLIED = 'jobapplied';
const JOBDETAIL = 'jobdetail';
const JOBFEED = 'jobfeed';
const RECRUITER_JOBFEED = 'recruiterJobfeed';
const SEARCH = 'search';
const TAG = 'tag';
const WOMEN_AT_WORK = 'women_at_work';
const ENGINEERS_WEEK = 'engineers_week';

const PopularTags = [
  {
    id: 5,
    name: 'Mobile Applications',
    alias: 'Mobile Applications',
    tags: [
      {
        id: 56,
        name: 'Android Developer',
        alias: 'Android Jobs',
        key: 'Android',
      },
      {id: 63, name: 'iOS Developer', alias: 'iOS Jobs', key: 'iOS'},
      {id: 68, name: 'Phonegap Developer', key: 'Phonegap'},
      {
        id: 0,
        name: 'Swift/Objective C Developer',
        searchString: 'Swift Objective C',
      },
    ],
    icon: 'icon-mobile-applications-jobs',
    meta: '',
  },
  {
    id: 2,
    name: 'Frontend Development',
    alias: 'Frontend Development',
    tags: [
      {id: 0, name: 'Frontend Developer', searchString: 'Frontend Development'},
      {id: '1900', name: 'Mean Stack Developer', key: 'Mean'},
      {
        id: 26,
        name: 'Javascript Engineer',
        alias: 'Javascript Jobs',
        key: 'Javascript',
      },
      {id: '434', name: 'Node.js Developer', key: 'Nodejs'},
    ],
    icon: 'icon-frontend-developer-jobs',
    meta: '',
  },
  {
    id: 1,
    name: 'Backend Development',
    alias: 'Backend Development',
    tags: [
      {id: 0, name: 'Backend Developer', searchString: 'Backend Development'},
      {id: 5, name: 'Java Developer', alias: 'Java Jobs', key: 'Java'},
      {id: 9, name: 'Python Developer', alias: 'Python Jobs', key: 'Python'},
      {id: '7', name: '.NET Developer', key: 'Net'},
    ],
    icon: 'icon-backend-developer-jobs',
    meta: '',
  },
  {
    id: 8,
    name: 'DevOps/SRE',
    alias: 'DevOps / SRE',
    tags: [
      {id: 0, name: 'DevOps Engineer', searchString: 'DevOps Engineer'},
      {id: '73', name: 'Network Administration', key: 'Network Administration'},
      {id: 1239, name: 'Azure', alias: 'Azure Jobs', key: 'Azure'},
      {id: '2631', name: 'Docker', key: 'Docker'},
      {id: '1551', name: 'Jenkins', key: 'Jenkins'},
    ],
    icon: 'icon-devops-jobs',
    meta: '',
  },
  {
    id: 9,
    name: 'Emerging Technologies',
    alias: 'Emerging Technologies',
    tags: [
      {
        id: 2240,
        name: 'Block Chain Developer',
        alias: 'Blockchain Jobs',
        key: 'Blockchain',
      },
      {id: '1641', name: 'iOT', key: 'iOT'},
      {
        id: 2211,
        name: 'Augmented Reality',
        alias: 'Augmented Reality Jobs',
        key: 'Augmented Reality',
      },
      {
        id: 2672,
        name: 'Virtual Reality',
        alias: 'Virtual Reality Jobs',
        key: 'Virtual Reality',
      },
      {id: '2625', name: 'Cryptography', key: 'Cryptography'},
    ],
    icon: 'icon-emerging-technologies-roles',
    meta: '',
  },
  {
    id: 7,
    name: 'Data Analytics & BI',
    alias: 'Data Analytics & BI',
    tags: [
      {id: '2023', name: 'Data Scientist', key: 'Data Scientist'},
      {id: '2111', name: 'Data Analyst', key: 'Data Analytics'},
      {id: '1400', name: 'Business Intelligence', key: 'Business Intelligence'},
      {id: '600', name: 'Tableau', key: 'Tableau'},
      {id: '2574', name: 'Power BI', key: 'Power BI'},
    ],
    icon: 'icon-analytics-data-science',
    meta: '',
  },
  {
    id: 13,
    name: 'Business Analysis and Project Management',
    alias: 'Project Management',
    tags: [
      {
        id: 156,
        name: 'Business Analyst',
        alias: 'Business Analyst Jobs',
        key: 'Business Analyst',
      },
      {
        id: 30,
        name: 'Project Manager',
        alias: 'Project Management Jobs',
        key: 'Project Management',
      },
      {id: '280', name: 'Scrum Master', key: 'Scrum'},
      {
        id: 98,
        name: 'Program Manager',
        alias: 'Program Management Jobs',
        key: 'Program Management',
      },
    ],
    icon: 'icon-project-managment',
    meta: '',
  },
  {
    id: 12,
    name: 'Product Management',
    alias: 'Product Management',
    tags: [
      {id: '28', name: 'Product Manager', key: 'Product Management'},
      {id: 0, name: 'Product Specialist', searchString: 'Product Specialist'},
      {id: 0, name: 'Product Owner', searchString: 'Product Owner'},
      {id: '2910', name: 'Product Roadmap', key: 'Product Roadmap'},
    ],
    icon: 'icon-product-managment',
    meta: '',
  },
  {
    id: 10,
    name: 'UI & Design',
    alias: 'UI & Design',
    tags: [
      {id: 0, name: 'Graphic Designer', searchString: 'Graphic Designer'},
      {id: '2915', name: 'Product Design', key: 'Product Design'},
      {id: 49, name: 'UI Designer', alias: 'UI Jobs', key: 'UI'},
      {id: 2, name: 'UX Designer', alias: 'UX Jobs', key: 'UX'},
    ],
    icon: 'icon-ui-design',
    meta: '',
  },
  {
    id: 4,
    name: 'Semiconductor/VLSI/EDA',
    alias: 'Semiconductor/VLSI/EDA',
    tags: [
      {id: 0, name: 'Embedded Engineeer', searchString: 'Embedded Engineeer'},
      {id: 426, name: 'RTL Design Engineer', alias: 'RTL Jobs', key: 'RTL'},
      {id: 191, name: 'Verilog', alias: 'Verilog Jobs', key: 'Verilog'},
      {id: '402', name: 'MATLAB', key: 'MATLAB'},
      {id: '197', name: 'VHDL', key: 'VHDL'},
    ],
    icon: 'icon-semiconductor-vlsi-eda',
    meta: '',
  },
  {
    id: 11,
    name: 'Quality Assurance',
    alias: 'Quality Assurance',
    tags: [
      {id: 0, name: 'Quality Analyst', searchString: 'Quality Analyst'},
      {id: 0, name: 'Test Engineer', searchString: 'Test Engineer'},
      {id: '187', name: 'Automation Testing', key: 'Automation Testing'},
      {id: '353', name: 'Selenium', key: 'Selenium'},
    ],
    icon: 'icon-quality-assurance',
    meta: '',
  },
  {
    id: 6,
    name: 'Platform Engineering/SAP/Oracle',
    alias: 'Platform Engineering / SAP/Oracle',
    tags: [
      {
        id: 455,
        name: 'Pega Developer',
        alias: 'Pega Developer Jobs',
        key: 'Pega',
      },
      {
        id: 268,
        name: 'Sharepoint Developer',
        alias: 'Sharepoint Jobs',
        key: 'Sharepoint',
      },
      {id: '217', name: 'ABAP Developer', key: 'SAP ABAP'},
      {id: '2317', name: 'Informatica', key: 'Informatica Architect'},
    ],
    icon: 'icon-enterprise-sap-oracle',
    meta: '',
  },
  {
    id: 3,
    name: 'Others',
    alias: 'Others',
    tags: [
      {id: '336', name: 'Technical Writer', key: 'Technical Writer'},
      {
        id: 2639,
        name: 'Cyber Security',
        alias: 'Cyber Security Jobs',
        key: 'Cyber Security',
      },
      {
        id: 1610,
        name: 'Ethical Hacking',
        alias: 'Ethical Hacking Jobs',
        key: 'Ethical Hacking',
      },
      {id: '1331', name: 'Internship', key: 'Internship'},
      {id: '1499', name: 'Walkin', key: 'Walkin'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 14,
    name: 'AI/ML',
    alias: 'AI/ML',
    tags: [
      {id: '203', name: 'Machine Learning Engineer', key: 'Machine Learning'},
      {
        id: 898,
        name: 'Artificial Intelligence',
        alias: 'Artificial Intelligence Jobs',
        key: 'Artificial Intelligence',
      },
      {
        id: 135480,
        name: 'Generative AI',
        alias: 'Generative AI Jobs',
        key: 'Generative AI',
      },
      {id: '2512', name: 'Deep Learning', key: 'Deep Learning'},
      {id: '357', name: 'NLP', key: 'NLP'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 15,
    name: 'Data Engineering',
    alias: 'Data Engineering',
    tags: [
      {id: '111', name: 'Big Data', key: 'Big Data'},
      {id: 112, name: 'Hadoop', alias: 'Hadoop Jobs', key: 'Hadoop'},
      {
        id: 7049,
        name: 'Data Pipeline',
        alias: 'Data Pipeline Jobs',
        key: 'Data Pipeline',
      },
      {id: '2475', name: 'Data Integration', key: 'Data Integration'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 16,
    name: 'Full Stack',
    alias: 'Full Stack',
    tags: [
      {id: '1612', name: 'Full Stack Developer', key: 'Full Stack'},
      {
        id: 2696,
        name: 'MERN Stack Developer',
        alias: 'MERN Stack Jobs',
        key: 'MERN Stack',
      },
      {
        id: 1900,
        name: 'MERN Stack Developer',
        alias: 'MEAN Stack Jobs',
        key: 'MEAN',
      },
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 17,
    name: 'CyberSecurity',
    alias: 'CyberSecurity',
    tags: [
      {id: '2623', name: 'Data Security', key: 'Data Security'},
      {
        id: 2584,
        name: 'Cloud Security',
        alias: 'Cloud Security Jobs',
        key: 'Cloud Security',
      },
      {id: 452, name: 'IAM', alias: 'IAM Jobs', key: 'IAM'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 0,
    name: 'Popular',
    alias: 'Popular for job',
    tags: [
      {
        id: '2023',
        name: 'Data Scientist',
        alias: 'Data Science',
        key: 'Data Scientist',
      },
      {id: '9', name: 'Python', alias: 'Python', key: 'Python'},
      {
        id: '203',
        name: 'Machine Learning',
        alias: 'Machine Learning',
        key: 'Machine Learning',
      },
      {
        id: 0,
        name: 'Android IOS',
        alias: 'Android/IOS',
        searchString: 'Android iOS',
      },
      {
        id: 0,
        name: 'Angular React JS',
        alias: 'Angular /React .JS',
        searchString: 'Angular React JS',
      },
      {id: '2696', name: 'MERN', alias: 'MERN', key: 'MERN Stack'},
      {id: 0, name: 'UX Designer', alias: 'UX', searchString: 'UX Designer'},
      {
        id: '30',
        name: 'Project Manager',
        alias: 'Project Manager',
        key: 'Project Management',
      },
      {
        id: '28',
        name: 'Product Manager',
        alias: 'Product manager',
        key: 'Product Management',
      },
      {id: '1612', name: 'Full Stack', alias: 'Full Stack', key: 'Full Stack'},
      {
        id: '17730',
        name: 'Data Analyst',
        alias: 'Data Analyst',
        key: 'Data Analyst',
      },
      {
        id: 0,
        name: 'Backend Developer Jobs',
        alias: 'Backend',
        searchString: 'Backend Developer',
      },
      {id: 0, name: 'Fintech Jobs', alias: 'Fintech'},
      {id: 0, name: 'Startup Jobs', alias: 'Startup'},
      {id: 0, name: 'Frontend Jobs', alias: 'Frontend'},
    ],
    icon: 'icon-others',
    meta: '',
  },
];

export {
  AUTH_TOKEN,
  AUTH_KEY,
  AUTH_EXPIRATION,
  STATUS,
  SECRET,
  JOBFEED_SLICE_NAME,
  JOBDETAIL_SLICE_NAME,
  USER_SLICE_NAME,
  APP_CONTEXT_SLICE_NAME,
  ADS_SLICE_NAME,
  AUTH_SLICE_NAME,
  COOKIE_LOGIN_AUTH,
  DOMAIN,
  COOKIE_USER_LAST_ACTIVE,
  COOKIE_RECRUITER,
  COOKIE_JINSTITUTES,
  OBS_ID,
  NON_AUTH_ENDPOINT,
  PAGEID,
  PAGELIST_ID,
  NOTIFICATION_STATUS,
  COMPETITION_SLICE_NAME,
  COMPANY,
  TRACKING_ACTIONS,
  getRefCodeAndTracking,
  COMPANY_JOBFEED_SLICE_NAME,
  CAT_ID_URL_MAPPING,
  experienceOptions,
  postingOptions,
  pageUrlMap,
  mapExpToBucket,
  HIRIST_CATEGORY_ID_MAPPING,
  HIRIST_CATEGORY_BLOG_ID_MAPPING,
  LOCATION_BASED,
  CATEGORY,
  JOBAPPLIED,
  JOBDETAIL,
  PopularTags,
  JOBFEED,
  RECRUITER_JOBFEED,
  SEARCH,
  TAG,
  WOMEN_AT_WORK,
  ENGINEERS_WEEK,
  COMPETITION_ID,
  EXPERIENCE_MAPPING,
  NON_AUTH_PAGE,
};
